export enum GuardHouseLogoutCodes {
  IntentionalLogout = 'GH2022',
  UnIntentionalLogout = 'GH2030',
}
